<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Opening Times</h5>
                    <div class="table-responsive">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">Weekday</th>
                                    <th class="border-bottom-0">From</th>
                                    <th class="border-bottom-0">To</th>
                                    <th class="border-bottom-0">Waiting Time</th>
                                    <th class="border-bottom-0">Rush Hour From</th>
                                    <th class="border-bottom-0">Rush Hour To</th>
                                    <th class="border-bottom-0">Waiting Time</th>
                                    <th class="border-bottom-0">Can Order From</th>
                                    <th class="border-bottom-0">Cannot Order From</th>
                                    <th class="border-bottom-0">Is Opened</th>
                                    <th class="border-bottom-0"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="o in openingtimes">
                                    <td> {{ getWeekday(o.label) }} </td>
                                    <td> {{ o.fromTime }} </td>
                                    <td> {{ o.toTime }} </td>
                                    <td> {{ o.defaultWaitingTime }} </td>
                                    <td> {{ o.rushHourFrom }} </td>
                                    <td> {{ o.rushHourTo }} </td>
                                    <td> {{ o.rushHourWaitingTime }} </td>
                                    <td> {{ o.canOrderFrom}} </td>
                                    <td> {{ o.cannotOrderFrom }} </td>
                                    <td> {{ o.isOpened }} </td>
                                    <td>
                                        <b-button-group>
                                            <b-button variant="primary" 
                                                      class="icon-btn"
                                                      v-on:click="handleBtnEdit(o)">
                                                <i class="mdi mdi-table-edit"></i>
                                            </b-button>
                                        </b-button-group>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions, mapState } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
export default{
    name: 'openingtimes',
    extends: RestaurantChangedBase,
    computed: {
        ...mapState({
            openingtimes: state => state.openingtimes.openingtimes
        })
    },
    methods: {
        ...mapActions(['openingtimes/getOpeningTimesAction']),
        handleBtnEdit(openingtime) {
            this.$router.push({ name: 'openingtimeeditform', params: { id: openingtime.label }});
        },
        getWeekday(label) {
            if (label === 0) {
                return 'Sun'
            }
            else if (label === 1) {
                return 'Mon'
            }
            else if (label === 2) {
                return 'Tue'
            }
            else if (label === 3) {
                return 'Wed'
            }
            else if (label === 4) {
                return 'Thu'
            }
            else if (label === 5) {
                return 'Fri'
            }
            else {
                return 'Sat'
            }
        }
    }, 
    async created() {
        await this.$store.dispatch('restaurants/getRestaurantsAction');
        await this.$store.dispatch('openingtimes/getOpeningTimesAction');
        this.setAction('openingtimes/getOpeningTimesAction');
    }
}
</script>